import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {Globals} from "../../../../../globals";
import {DishServices} from "../../../services";

/**
 * Generated class for the PartialPageTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-partial-allergens',
    templateUrl: 'dish-partial-allergens.html',
})
export class DishPartialAllergensPage {

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public globals: Globals,
                public dishServices: DishServices) {
    }

    checkState(allergen_uid) {
        var index = this.dishServices.dish_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            return true
        } else {
            return false
        }

    }

    insert(allergen_uid) {
        this.dishServices.dish_allergens_tmp.push(allergen_uid);
    }

    delete(allergen_uid) {
        var index = this.dishServices.dish_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            this.dishServices.dish_allergens_tmp.splice(index, 1);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-allergens/dish-partial-allergens/dish-partial-allergens.ts